<template>
  <SoWidget no-border no-padding class="flex-basis-helper mb-6">
    <div class="mb-2 mx-6">
      <h6 class="font-weight-medium my-6">{{ title }}</h6>
      <SoSkeleton v-if="loading" class="text-h4 pb-1" />
      <div v-else>
        <slot />
      </div>
      <a
        v-if="expandable"
        href="javascript:;"
        class="show-details-btn d-flex align-center mt-6"
        data-testid="widget-expand"
        @click="showDetails = !showDetails"
      >
        <span class="mr-1">See Details</span>
        <SoIcon
          :icon="showDetails ? 'chevron-up' : 'chevron-down'"
          size="small"
          class="ml-2"
        />
      </a>
    </div>
    <template #expand>
      <div v-show="(showDetails && expandable) || !expandable" class="mx-6">
        <SoDivider v-if="expandable" class="mb-6" />
        <slot name="details" />
      </div>
    </template>
  </SoWidget>
</template>

<script lang="ts">
  import SoDivider from "@/components/SoDivider.vue"
  import SoIcon from "@/components/SoIcon.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import { defineComponent } from "vue"

  export default defineComponent({
    components: {
      SoWidget,
      SoIcon,
      SoDivider,
      SoSkeleton,
    },
    props: {
      title: {
        type: String,
        default: "",
      },
      loading: {
        type: Boolean,
        default: false,
      },
      expandable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showDetails: false,
      }
    },
  })
</script>

<style scoped>
  .flex-basis-helper {
    flex: 1 1 0px;
  }
  .show-details-btn {
    color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
    text-decoration: none;
  }
  .show-details-btn:focus-visible {
    outline: var(--theme-outline);
    border-radius: var(--theme-radius);
  }
</style>
